import {
  stringify,
  parse,
  useTimestampValue,
  TimestampValue,
  type TimestampValueOptions
} from "@zyzgroup/core-common";

// localStorage 存储的数据可以跨浏览器会话访问
// LocalStorage 的范围： 同源（Same Origin） + 浏览器实例，只要域名一样，所有 Tab 共享数据

// 存储量 5MB

// 不会带到 HTTP 请求中，仅位于浏览器端，不与服务端发生通信

export function useLocalStorage(
  key: string | symbol,
  options?: TimestampValueOptions
) {
  const k = typeof key == "string" ? key : key.toString();

  const getInDom = () => {
    try {
      const fromLocal = window.localStorage.getItem(k);
      if (fromLocal) {
        return parse(fromLocal);
      }
    } catch (e) {
      // do nothing
    }
    return undefined;
  };

  // write or remove
  const setInDom = (timestampValue: TimestampValue) => {
    try {
      if (typeof timestampValue.value != "undefined") {
        window.localStorage.setItem(k, stringify(timestampValue));
      } else {
        window.localStorage.removeItem(k);
      }
    } catch (e) {
      // do nothing
    }
  };

  const get = () => {
    const { get: getTimestampValue } = useTimestampValue(getInDom(), options);
    const timestampValue = getTimestampValue();
    return timestampValue.value;
  };

  const set = (v: any) => {
    const { set: setTimestampValue } = useTimestampValue(getInDom(), options);
    const value = setTimestampValue(v);
    setInDom(value);
  };

  return {
    get,
    set
  };
}

export function clearLocalStorage() {
  window.localStorage.clear();
}
